module.exports = __webpack_public_path__ + "static/media/payment-banner.6a0eb24d.png";